import { Card, LoadingSpinner } from '../ui';

export default function ChartContainer({
  title,
  children,
  loading = false,
  error = null,
  height = 300,
  className = ''
}) {
  return (
    <Card className={className}>
      {title && (
        <h3 className="text-lg font-semibold text-text-primary-light dark:text-text-primary mb-4">
          {title}
        </h3>
      )}
      <div style={{ height: `${height}px` }} className="w-full">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <LoadingSpinner />
          </div>
        ) : error ? (
          <div className="flex items-center justify-center h-full text-danger-dark dark:text-danger">
            <p>{error}</p>
          </div>
        ) : children ? (
          children
        ) : (
          <div className="flex items-center justify-center h-full text-text-muted-light dark:text-text-muted">
            <p>No data available</p>
          </div>
        )}
      </div>
    </Card>
  );
}
